import { useEffect, useState } from "react";
import { api } from "../lib/api";

const lbl = "font-mono text-[10px] tracking-[0.2em] text-[#6B7280]";
const inp = "no-spin h-12 px-3 font-mono bg-[#090D16] border border-[#334155] rounded-md focus:outline-none focus:border-[#F59E0B] w-full";

export function useMachines() {
  const [ms, setMs] = useState([]);
  useEffect(() => { api.get("/machines").then((r) => setMs(r.data)).catch(() => {}); }, []);
  return ms;
}

export const resFromBom = (b) => ({ resource_type: b?.resource_type || "operator", machine_id: b?.machine_id || "", production_time_minutes: b?.production_time_minutes || 0,
  setup_labor_minutes: b?.setup_labor_minutes || 0, machine_run_minutes: b?.machine_run_minutes || 0 });

export const resBody = (r) => ({ resource_type: r.resource_type, machine_id: r.resource_type === "machine" ? r.machine_id || null : null,
  production_time_minutes: Number(r.production_time_minutes) || 0, setup_labor_minutes: Number(r.setup_labor_minutes) || 0, machine_run_minutes: Number(r.machine_run_minutes) || 0 });

export default function ResourceFields({ res, setRes, machines }) {
  const set = (k) => (e) => setRes({ ...res, [k]: e.target.value });
  const isM = res.resource_type === "machine";
  return (
    <div className="grid gap-3 p-4 rounded-md border border-[#1E293B]" data-testid="bom-resource">
      <div className={lbl}>RESOURCE ASSIGNMENT</div>
      <div className="grid grid-cols-2 gap-2">
        {[["operator", "Operator (Payroll)"], ["machine", "Machine Resource"]].map(([v, l]) => (
          <button key={v} type="button" data-testid={`bom-resource-${v}`} onClick={() => setRes({ ...res, resource_type: v })}
            className={`h-11 rounded-md border text-sm font-semibold ${res.resource_type === v ? "bg-white text-[#090D16] border-white" : "border-[#334155] text-[#9CA3AF]"}`}>{l}</button>
        ))}
      </div>
      {!isM ? (
        <label className="flex flex-col gap-1"><span className={lbl}>PRODUCTION TIME PER UNIT (MINS)</span>
          <input type="number" step="any" min="0" data-testid="bom-production-time-input" className={inp} value={res.production_time_minutes} onChange={set("production_time_minutes")} /></label>
      ) : (
        <>
          <select data-testid="bom-machine-select" value={res.machine_id} onChange={set("machine_id")} className="h-12 px-3 bg-[#090D16] border border-[#334155] rounded-md">
            <option value="">Select a machine…</option>
            {machines.map((m) => <option key={m.id} value={m.id} disabled={!m.active_status}>{m.machine_name} · ${m.hourly_operating_cost}/h{m.active_status ? "" : " (inactive)"}</option>)}
          </select>
          {!machines.length && <div className="text-xs text-[#F59E0B]">No machines yet. Add one in Master Controls → Machines & Work Centers.</div>}
          <div className="grid grid-cols-2 gap-3">
            <label className="flex flex-col gap-1"><span className={lbl}>SETUP LABOR (MIN / UNIT)</span><input type="number" step="any" min="0" data-testid="bom-setup-input" className={inp} value={res.setup_labor_minutes} onChange={set("setup_labor_minutes")} /></label>
            <label className="flex flex-col gap-1"><span className={lbl}>MACHINE RUN (MIN / UNIT)</span><input type="number" step="any" min="0" data-testid="bom-run-input" className={inp} value={res.machine_run_minutes} onChange={set("machine_run_minutes")} /></label>
          </div>
          <div className="text-[11px] text-[#6B7280]">Only setup labour counts against daily shop hours. Run time books the machine's own hours.</div>
        </>
      )}
    </div>
  );
}
